import { render, staticRenderFns } from "./dialogDetail.vue?vue&type=template&id=245304e0&scoped=true"
import script from "./dialogDetail.vue?vue&type=script&lang=js"
export * from "./dialogDetail.vue?vue&type=script&lang=js"
import style0 from "./dialogDetail.vue?vue&type=style&index=0&id=245304e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245304e0",
  null
  
)

export default component.exports